import { Injectable } from "@angular/core";

@Injectable()
export class Globals {
  URL_CURSEUR: string = "http://localhost:4201";
}
